import React, {useState} from "react";
import {
  Box,
  IconButton,
  Table, TableBody, TableCell, TableHead, TableRow,
  Tooltip,
  Typography
} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconPencil, IconPlus, IconTrash} from "@tabler/icons-react";
import {CreateVarModal} from "./CreateVarModal";
import {CreateVariableModal} from "../settings/CreateVariableModal";
import {NodeType} from "../../../../../model/ModelData";

export const VarsTab = ({node, onUpdate, project}) => {
  const {primary, secondary} = menuItemsInfo.vars;
  const [open, setOpen] = useState(false);
  const [selectedVar, setSelectedVar] = useState(null);

  return (
    <>
      <CreateVariableModal
        open={open}
        handleClose={() => {
          setOpen(false);
          setSelectedVar(null);
        }}
        project={project}
        editParam={selectedVar} isForm={!!node?.data?.form_id}
        onUpdateParams={(newParams) => {
          console.log(newParams);
          const newNode = {...node};
          newNode.data.params = newParams || [];
          onUpdate(newNode)
        }}
        params={node?.data?.params || []}
      />
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{fontWeight: 600, fontSize: 13, py: 1, px: 0.5}}>From</TableCell>
            <TableCell sx={{fontWeight: 600, fontSize: 13, py: 1, px: 0.5}}>Target</TableCell>
            <TableCell padding={"checkbox"} sx={{fontWeight: 600, fontSize: 13, width: "auto"}}>
              <Tooltip title={"Add new variable"}>
                <IconButton
                  variant={"outlined"}
                  size={"small"}
                  onClick={() => setOpen(true)}
                >
                  <IconPlus size={18} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {node?.data?.params?.map((param, index) => {
            return (
              <TableRow key={`${param.uid}-${index}`}>
                <TableCell sx={{fontSize: 12, py: 1, px: 0.5}}>
                  <Typography noWrap>({param?.source_scope})  {param?.source}</Typography>
                </TableCell>
                <TableCell sx={{fontSize: 12, py: 1, px: 0.5}}>
                  <Typography noWrap>({param?.target_scope})  {param?.target}</Typography>
                </TableCell>
                <TableCell padding={"checkbox"} sx={{width: "auto"}}>
                  <IconButton
                    variant={"outlined"}
                    size={"small"}
                    fullWidth
                    onClick={() => {
                      setSelectedVar(param);
                      setOpen(true)
                    }}
                  >
                    <IconPencil size={18}/>
                  </IconButton>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>

    </>
  )
}